import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DISCORD_URL, EMAIL_SUPPORT } from '@app/config';
import { FaqAccordionComponent, SectionHeaderComponent } from '@app/widgets';
import { LIVE_UPDATES_FAQS } from '../../constants';

@Component({
  selector: 'app-live-updates-faq-section',
  imports: [SectionHeaderComponent, FaqAccordionComponent],
  templateUrl: './live-updates-faq-section.component.html',
  styleUrl: './live-updates-faq-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveUpdatesFaqSectionComponent {
  protected readonly discordUrl = DISCORD_URL;
  protected readonly emailSupport = EMAIL_SUPPORT;
  protected readonly items = LIVE_UPDATES_FAQS;
}
